export default "__VITE_ASSET__BWB7pvgF__"